import { render, staticRenderFns } from "./ViewBioProfile.vue?vue&type=template&id=3dbab286&scoped=true&"
import script from "./ViewBioProfile.vue?vue&type=script&lang=js&"
export * from "./ViewBioProfile.vue?vue&type=script&lang=js&"
import style0 from "./ViewBioProfile.vue?vue&type=style&index=0&id=3dbab286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbab286",
  null
  
)

export default component.exports